import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "col" }
const _hoisted_2 = {
  class: "card",
  "aria-hidden": "true"
}
const _hoisted_3 = { class: "card-footer text-body-secondary d-flex align-items-center" }
const _hoisted_4 = {
  key: 0,
  class: "btn btn-primary btn-action ms-auto disabled placeholder col-6"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createStaticVNode("<img src=\"https://placehold.co/150x100/CCCCCC/CCCCCC/png?text=.\" class=\"card-img-top bg-dark\" alt=\"loaging\" data-v-0bdd54ba><div class=\"card-body\" data-v-0bdd54ba><img src=\"https://placehold.co/35x25/CCCCCC/CCCCCC/png?text=.\" class=\"w-auto h-100 logo mt-2\" data-v-0bdd54ba><p class=\"m-0 card-text text-primary placeholder-glow\" data-v-0bdd54ba><small class=\"placeholder col-4\" data-v-0bdd54ba></small></p><p class=\"card-text placeholder-glow\" data-v-0bdd54ba><strong class=\"placeholder col-6\" data-v-0bdd54ba></strong></p></div>", 2)),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.admin)
          ? (_openBlock(), _createElementBlock("button", _hoisted_4))
          : _createCommentVNode("", true),
        _cache[0] || (_cache[0] = _createElementVNode("button", { class: "btn btn-secondary btn-trash ms-2 disabled placeholder col-6" }, null, -1))
      ])
    ])
  ]))
}